/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { accessSync } from 'fs';
import moment from 'moment';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const getHeader = (currentPage, pageCount, data) => {
  const { qtr, prinDate, requestedBy, reportName, requestorUserId } = data;
  const header = {
    alignment: 'center',
    fontSize: 10,
    margin: [28.8, 20, 28.8, 25.92],
    style: 'tableExample',
    table: {
      widths: [190, 180, 150],
      body: [
        [
          {
            text: [{ text: 'Requested By: ', bold: true }, requestedBy],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: reportName,
            fontSize: 12,
            bold: true,
            fontFamily: 'arial',
            alignment: 'center',
          },
          {
            text: [{ text: 'Date Printed: ', bold: true }, prinDate],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
        [
          {
            text: '',
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: qtr,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'center',
            bold: true,
          },
          {
            text: `Page ${currentPage} of ${pageCount}`,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
      ],
    },
    layout: 'noBorders',
  };
  return header;
};

const contentFont = 10;
const pageMargins = [42, 80, 28.8, 25.92];
const getRightGridTable = (oneRebate) => {
  const dataToReturn = [];
  let totaRecordCount = 0;
  for (let i = 0; i < oneRebate.length; i += 1) {
    dataToReturn.push([
      {
        text: oneRebate[i].claimLoadDt,
        fontSize: contentFont,
        border: [false, false, false, false],
      },
      {
        text: oneRebate[i].recordCount.toLocaleString('en-US'),
        alignment: 'right',
        fontSize: contentFont,

        border: [false, false, false, false],
      },
    ]);
    totaRecordCount += oneRebate[i].recordCount;
  }
  dataToReturn.push([
    {
      text: 'Total:',
      bold: true,
      fontSize: contentFont,
      border: [false, true, false, false],
    },
    {
      text: totaRecordCount.toLocaleString('en-US'),
      alignment: 'right',
      fontSize: contentFont,
      bold: true,
      border: [false, true, false, false],
    },
  ]);
  return dataToReturn;
};
const getLeftGridTable = (oneRebate) => {
  const dataToReturn = [];
  for (let i = 0; i < oneRebate.length; i += 1) {
    if (oneRebate[i].head) {
      const topBerder = i == oneRebate.length - 1;
      dataToReturn.push([
        {
          text: '',
          border: [false, false, false, false],
        },
        {
          text: '',
          border: [false, false, false, false],
        },
      ]);
      dataToReturn.push([
        {
          text: oneRebate[i].title,
          bold: true,
          fontSize: contentFont,
          border: [false, topBerder, false, false],
        },
        {
          text: oneRebate[i].recordCount?.toLocaleString('en-US') || '',
          bold: true,
          alignment: 'right',

          fontSize: contentFont,
          border: [false, topBerder, false, false],
        },
      ]);
    } else {
      dataToReturn.push([
        {
          text: oneRebate[i].title,
          fontSize: contentFont - 1,
          border: [false, false, false, false],
        },
        {
          text: oneRebate[i].recordCount?.toLocaleString('en-US'),
          alignment: 'right',
          fontSize: contentFont - 1,
          border: [false, false, false, false],
        },
      ]);
    }
  }
  return dataToReturn;
};

const getTableBody = (data) => {
  const { leftGridData, rightGridData } = data;
  const body = [];
  const rebates = Object.keys(leftGridData);
  const newObj = rebates?.sort((a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  });
  for (let i = 0; i < newObj.length; i += 1) {
    body.push({
      text: [
        { text: 'Rebate Program Cd: ', bold: true, fontSize: contentFont },
        { text: newObj[i], fontSize: contentFont },
      ],
    });
    body.push({
      style: 'myTable',
      table: {
        widths: ['*', 30, '*'],
        body: [
          [
            {
              style: 'tableExample',
              table: {
                headerRows: 0,
                widths: ['*', 100],
                body: getLeftGridTable(leftGridData[newObj[i]]),
              },
            },
            '',
            {
              style: 'myTable',
              table: {
                headerRows: 0,
                widths: ['*', 100],
                body: [
                  [
                    {
                      text: 'Load Date ',
                      bold: true,
                      fontSize: contentFont,
                      border: [false, false, false, true],
                    },
                    {
                      text: 'Count',
                      alignment: 'right',
                      bold: true,
                      fontSize: contentFont,
                      border: [false, false, false, true],
                    },
                  ],
                  ...getRightGridTable(rightGridData[newObj[i]]),
                ],
              },
            },
          ],
        ],
      },
      layout: 'noBorders',
    });
    if (i < rebates.length - 1)
      body.push({
        text: '',
        fontSize: 14,
        bold: true,
        pageBreak: 'before',
        margin: [0, 0, 0, 8],
      });
  }
  return body;
};

const styles = {
  header: {
    fontSize: 18,
    bold: true,
    margin: [0, 0, 0, 10],
  },
  subheader: {
    fontSize: 16,
    bold: true,
    margin: [0, 10, 0, 5],
  },
  tableExample: {
    margin: [0, 5, 0, 15],
  },
  tableHeader: {
    bold: true,
    fontSize: 13,
    color: 'black',
  },
};
const getPdfData = (bodyData, headerData) => {
  const content = getTableBody(bodyData);
  const currentYear = new Date().getFullYear();
  return {
    header: (currentPage, pageCount) => {
      return getHeader(currentPage, pageCount, headerData);
    },
    footer: () => {
        const footers = [];
        footers.push({
          text:`${currentYear} Conduent Business Services, LLC. All rights reserved. Conduent and Conduent Agile Star are trademarks of Conduent Business Services, LLC in the United States and/or other countries.`,
          fontSize: 8,
          color: '#636363',
          fontFamily: 'Arial',
          alignment: 'center',
        });

      return footers;
    },
    content,
    pageMargins,
    styles,
    // pageOrientation: 'landscape',
  };
};
export const exportAllData = (
  bodayData,
  UserDefaultValues,
  { qtr, requestorUserId },
  logInUser,
  filename
) => {
  const headerData = {
    prinDate: moment(new Date()).format('MM/DD/YYYY'),
    requestedBy:
      UserDefaultValues && UserDefaultValues.userId
        ? UserDefaultValues.userId
        : logInUser,
    reportName: 'Quarterly Claim Reconciliation',
    qtr,
    requestorUserId,
  };
  const pdfData = getPdfData(bodayData, headerData);
  pdfMake
    .createPdf(pdfData)
    .download(`${filename}.pdf` || 'QuarterlyClaimReconciliation.pdf');
};
